import script from "./contactAssistant.vue?vue&type=script&setup=true&name=ContactAssistant&lang=js"
export * from "./contactAssistant.vue?vue&type=script&setup=true&name=ContactAssistant&lang=js"

import "./contactAssistant.vue?vue&type=style&index=0&id=152cd6e7&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-152cd6e7"]])

export default __exports__